module.exports = __webpack_public_path__ + "img/electronic_electric_use_selected.42041edb.svg";